"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_1 = __importDefault(require("../helpers/currency"));
var LineItemTable = /** @class */ (function () {
    function LineItemTable() {
    }
    LineItemTable.prototype.init = function () {
        document.addEventListener('quantity:change', this.handleQuantityChange.bind(this));
    };
    LineItemTable.prototype.handleQuantityChange = function (event) {
        var _this = this;
        document.querySelectorAll("[data-line-item-total-price=\"".concat(event.detail.key, "\"]")).forEach(function (lineItemTotalPrice) {
            _this.updateLineItemTotalPrice(lineItemTotalPrice, event);
        });
    };
    LineItemTable.prototype.updateLineItemTotalPrice = function (lineItemTotalPrice, event) {
        lineItemTotalPrice.innerText = currency_1.default.format(event.detail.price * event.detail.quantity);
        this.updateSubtotal();
    };
    LineItemTable.prototype.updateSubtotal = function () {
        var subtotal = document.querySelector('[data-subtotal-price]');
        subtotal.innerText = currency_1.default.format(this.calcSubtotal());
    };
    LineItemTable.prototype.calcSubtotal = function () {
        return Array.from(document.querySelectorAll('[data-line-item-total-price]')).reduce(function (accumulator, lineItemTotalPrice) {
            var lineItemTotalPriceValue = currency_1.default.parseFromStringToPrice(lineItemTotalPrice.innerText);
            accumulator += lineItemTotalPriceValue;
            return accumulator;
        }, 0);
    };
    return LineItemTable;
}());
exports.default = new LineItemTable();
